// 树相关接口

/**
 * 树广度优先搜索
 * @param {Array} data 搜索数据
 * @param {String} childName 子节点名称
 * @param {Function} func 搜索函数
 * @returns {Object} 搜索到的结果
 */
export function searchBFS (data, childName, func) {
  const list = []
  const result = []
  for (let i = 0; i < data.length; i++) {
    list.push(data[i])
  }
  let index = 0
  while (index < list.length) {
    if (func(list[index])) {
      result.push(list[index])
    }
    if (list[index][childName] && list[index][childName].length > 0) {
      for (let j = 0; j < list[index][childName].length; j++) {
        list.push(list[index][childName][j])
      }
    }
    index++
  }
  return result
}
/**
 * 树深度优先搜索
 * @param {Array} data 搜索数据
 * @param {*} childName 子节点名称
 * @param {*} func 搜索函数
 * @returns {Object} 搜索到的结果
 */
export function searchDFS (data, childName, func) {

}

/**
 * 树遍历节点
 * @param {Object} data 树数据
 * @param {String} childName 子节点名称
 * @param {Function} func 遍历函数
 */
export function treeForeach (data, childName, func) {
  for (let i = 0; i < data.length; i++) {
    func(data[i])
    if (data[i][childName] && data[i][childName].length > 0) {
      treeForeach(data[i][childName], childName, func)
    }
  }
}

/**
 * 树排序
 * @param {Object} data 树数据
 * @param {String} childName 子节点名称
 * @param {Function} func 遍历函数
 */
export function treeSort (data, childName, func) {
  if (data.length && data.length > 1) {
    data.sort(func)
  }
  for (let i = 0; i < data.length; i++) {
    if (data[i][childName] && data[i][childName].length > 0) {
      treeSort(data[i][childName], childName, func)
    }
  }
  // for (let i = 0; i < data.length; i++) {
  //   func(data[i])
  //   if (data[i][childName] && data[i][childName].length > 0) {
  //     treeSort(data[i][childName], childName, func)
  //   }
  // }
}
